import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import useDimensions from 'react-use-dimensions'

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts'

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
  },
}))

// will fill 100% of the width
const BarChartComponent = ({
  data,
  height = 300,
  margin = {
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  labelKey = 'name',
  labelFormatter = value => value,
  valueKey = 'value',
  valueTitle = 'value',
  valueFormatter = value => value,
  color,
}) => {

  const classes = useStyles()
  const [ref, { width }] = useDimensions()

  const theme = useTheme()
  color = color || theme.palette.secondary.main

  return (
    <div className={ classes.container } ref={ ref }>
      <BarChart
        width={ width }
        height={ height }
        data={ data }
        margin={ margin }
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={ labelKey } />
        <YAxis
          tickFormatter={ valueFormatter }
        />
        <Tooltip
          labelFormatter={ labelFormatter }
          formatter={ (value) => [valueFormatter(value), valueTitle] }
        />
        <Bar dataKey={ valueKey } fill={ color } />
      </BarChart>
    </div>
    
  );
}

export default BarChartComponent